const candidateRoles = [
  { role: "CDA Candidate" },
  { role: "Trainer" },
  { role: "Other Viewer" },
];

const CSIAdminRoles = [
  { role: "CSI Admin" },
  { role: "Council Admin" },
  { role: "CDA Candidate" },
  { role: "Trainer" },
  { role: "PD Specialist" },
  { role: "Employer/Mentor/Collegue" },
];

const CouncilAdminRoles = [
  { role: "Council Admin" },
  { role: "CDA Candidate" },
  { role: "Trainer" },
  { role: "PD Specialist" },
  { role: "Employer/Mentor/Collegue" },
];

const CSIAdminRolesAdmin = [{ role: "CSI Admin" }, { role: "Council Admin" }];

const CouncilAdminRolesAdmin = [{ role: "Council Admin" }];

const states = [
  { abbreviation: "AL", name: "Alabama" },
  { abbreviation: "AK", name: "Alaska" },
  { abbreviation: "AZ", name: "Arizona" },
  { abbreviation: "AR", name: "Arkansas" },
  { abbreviation: "CA", name: "California" },
  { abbreviation: "CO", name: "Colorado" },
  { abbreviation: "CT", name: "Connecticut" },
  { abbreviation: "DE", name: "Delaware" },
  { abbreviation: "FL", name: "Florida" },
  { abbreviation: "GA", name: "Georgia" },
  { abbreviation: "HI", name: "Hawaii" },
  { abbreviation: "ID", name: "Idaho" },
  { abbreviation: "IL", name: "Illinois" },
  { abbreviation: "IN", name: "Indiana" },
  { abbreviation: "IA", name: "Iowa" },
  { abbreviation: "KS", name: "Kansas" },
  { abbreviation: "KY", name: "Kentucky" },
  { abbreviation: "LA", name: "Louisiana" },
  { abbreviation: "ME", name: "Maine" },
  { abbreviation: "MD", name: "Maryland" },
  { abbreviation: "MA", name: "Massachusetts" },
  { abbreviation: "MI", name: "Michigan" },
  { abbreviation: "MN", name: "Minnesota" },
  { abbreviation: "MS", name: "Mississippi" },
  { abbreviation: "MO", name: "Missouri" },
  { abbreviation: "MT", name: "Montana" },
  { abbreviation: "NE", name: "Nebraska" },
  { abbreviation: "NV", name: "Nevada" },
  { abbreviation: "NH", name: "New Hampshire" },
  { abbreviation: "NJ", name: "New Jersey" },
  { abbreviation: "NM", name: "New Mexico" },
  { abbreviation: "NY", name: "New York" },
  { abbreviation: "NC", name: "North Carolina" },
  { abbreviation: "ND", name: "North Dakota" },
  { abbreviation: "OH", name: "Ohio" },
  { abbreviation: "OK", name: "Oklahoma" },
  { abbreviation: "OR", name: "Oregon" },
  { abbreviation: "PA", name: "Pennsylvania" },
  { abbreviation: "RI", name: "Rhode Island" },
  { abbreviation: "SC", name: "South Carolina" },
  { abbreviation: "SD", name: "South Dakota" },
  { abbreviation: "TN", name: "Tennessee" },
  { abbreviation: "TX", name: "Texas" },
  { abbreviation: "UT", name: "Utah" },
  { abbreviation: "VT", name: "Vermont" },
  { abbreviation: "VA", name: "Virginia" },
  { abbreviation: "WA", name: "Washington" },
  { abbreviation: "WV", name: "West Virginia" },
  { abbreviation: "WI", name: "Wisconsin" },
  { abbreviation: "WY", name: "Wyoming" },
  { abbreviation: "AS", name: "American Samoa" },
  { abbreviation: "GU", name: "Guam" },
  { abbreviation: "MH", name: "Republic of the Marshall Islands" },
  { abbreviation: "FM", name: "Federated States of Micronesia" },
  { abbreviation: "MP", name: "Commonwealth of the Northern Mariana Islands" },
  { abbreviation: "PW", name: "Republic of Palau" },
  { abbreviation: "PR", name: "Puerto Rico" },
  { abbreviation: "VI", name: "U.S. Virgin Islands" },
  { abbreviation: "DC", name: "District of Columbia" },
  { abbreviation: "AA", name: "Armed Forces Americas" },
  { abbreviation: "AE", name: "Armed Forces Europe" },
  { abbreviation: "AP", name: "Armed Forces Pacific" }
];

const credentialTypes = [
  { id: 0, name: "" },
  { id: 1, name: "Infant-Toddler" },
  { id: 2, name: "Preschool" },
  { id: 3, name: "Family Child Care" },
  { id: 4, name: "Home Visitor" },
];

const SharedAccessCredential = [{ role: "Trainer" }, { role: "Other Viewer" }];
const languageVersion = [{ language: "Spanish" }];

const languageSpecializtion = [{ specialization: "Bilingual" }];

const util = {
  states,
  candidateRoles,
  CSIAdminRoles,
  CouncilAdminRoles,
  CSIAdminRolesAdmin,
  CouncilAdminRolesAdmin,
  languageSpecializtion,
  languageVersion,
  credentialTypes,
  SharedAccessCredential,
};

export default util;
